// extracted by mini-css-extract-plugin
export default {"page":"NetworkPrices_page__KinhM","body":"NetworkPrices_body__GHHMx"};